/**
 * A príjemka's number: PR (príjemka) and its ID, "PR737" (SIG-461, S-492) — the number Frontflip admin
 * shows and searches it by. Mirrors GoodsReceipt.FormatNumber on the server.
 */
export const formatGoodsReceiptNumber = (goodsReceiptId: number) => `PR${goodsReceiptId}`;
